import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  apiBaseUrl: 'https://mindmaps-dev-nodejs-1018289389121.us-central1.run.app', //
  //apiBaseUrl: 'http://localhost:8080', // Local development API endpoint (using HTTP),
  googleClientId: '1018289389121-lfn7vmqnvmoa7f5pb77gptv996a6s59u.apps.googleusercontent.com',
  ga4MeasurementId: 'G-RE9JSRWRDW' // Replace with your actual GA4 Measurement ID
};
